export default "__VITE_ASSET__B41DuVXp__"